// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"polyfill~intersectionObserver":"acf93f93caf93bd1cded","polyfill~fetch":"6ad868c098a97c0e36f4","node_modules_siema_dist_siema_min_js":"0e0295d4b29d5847ca50"}[chunkId] + ".chunk.js";
};